export default __webpack_public_path__ + "static/media/tutorial-tree.d0628259.PNG";